import React, { useEffect, useState, Suspense, } from 'react';
import { /* Container, */ Col, Row } from "react-bootstrap";
import Button from '@mui/material/Button';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DownloadIcon from '@mui/icons-material/Download';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { message } from 'antd';
import {
    setFile, getFile, getStyle, setObjective, getBizID, setMemberSuccess, setMemberFail, getRoles,
    setStepRedux, getStepRedux, getCurrentRole, getServices,
} from '../../../../libs/todoSlice'
import LoadingComponent from '../../../../lib/LoadingComponent';
import fontColor from '../../../../lib/fontColor';
import { getImportModal, getManageMemberStep, getTabStep, setImportModal, setManageMemberStep, setTabStepRedux } from '../../../../libs/sideBarSlice';

import ExcelImportPreRegisterEduStudent from '../../../Excel/ExcelImportPreRegisterEduStudent';

import axios from 'axios';
import StudentTable from './StudentTable';
import AddStudent from './AddStudent';
import AddStudentHistory from './AddStudentHistory';
import StudentHistoryDetail from './StudentHistoryDetail';

function Student() {
    function BootstrapDialogTitle(props) {
        const { children, onClose, ...other } = props;
        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    }
    BootstrapDialogTitle.propTypes = {
        children: PropTypes.node,
        onClose: PropTypes.func.isRequired,

    };
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()
    const roles = useSelector(getCurrentRole)
    const file = useSelector(getFile)
    const style = useSelector(getStyle)
    const biz_id = useSelector(getBizID)
    const tabStep = useSelector(getTabStep)
    const setTabStep = (action) => {
        dispatch(setTabStepRedux({
            tabStep: action
        }))
    }

    const open = useSelector(getImportModal)
    const setOpen = (action) => {
        dispatch(setImportModal({
            importModal: action
        }))
    }
    const step = useSelector(getManageMemberStep)
    const setStep = (name) => {
        dispatch(setManageMemberStep({
            manageMemberStep: name
        }))
    }
    const handleChange = (event, newValue) => {
        setTabStep(newValue);
    };
    const handleClickOpen = () => {
        setFormName(['edu-student-pre-register'])
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        dispatch(setFile({
            file: [],
            filename: '',
            file_id: ''
        }))
    };
    const services = useSelector(getServices)

    useEffect(() => {
        
        if (roles.length !== 0) {
            if (roles !== 'RA' && roles !== 'owner') {
                if (services.includes('digital-workflow')) {
                    navigate(`/${params.prefix}/services/digital-workflow`)
                }
                else {
                    navigate(`/${params.prefix}/home`)
                }
            }
        }
    },[roles])

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
            background: 'transparent',
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
            background: 'transparent',
        },
    }));

    const donwloadExcel = async () => {
        await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel/export/edu-student-pre-register/pre-registers?business_id=${biz_id}`,
        }).then(({ data, status }) => {
            const base64String = data.data
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            const date = new Date();
            link.download = biz_id + "_" + date.getDate() + "-" + date.getMonth() + "-" + date.getFullYear() + '.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }, ({ response, status }) => {
        })
    }
    const [formName, setFormName] = useState(['edu-student-pre-register']);

    const manageCheckbox = () => {
      const list = [
          {
            show: true,
            element: (
              <MenuItem value="edu-student-pre-register">
              <ListItemText primary='edu-student-pre-register' />
              </MenuItem>
            )
          },
          {
            show: true,
            element: (
              <MenuItem value="edu-student-pre-register-combine">
              <ListItemText primary='edu-student-pre-register-combine' />
              </MenuItem>
            )
          },
      ].filter(l => l.show)
      return (
        <FormControl sx={{ m: 1, width: 300 }}
          style={{  width: '100%' }}>
          <InputLabel labelId="เลือกรูปแบบการส่งข้อมูล">เลือกรูปแบบการส่งข้อมูล</InputLabel>
          <Select
            labelId="เลือกรูปแบบการส่งข้อมูล"
            label='เลือกรูปแบบการส่งข้อมูล'
            value={formName}
            onChange={handleChangeSelectCheck}
            style={{
              width: '300px'
            }}
          >
            {list.map(item => item.element)}
          </Select>
        </FormControl>
      )
    }
  
    const handleChangeSelectCheck = (event) => {
      const {
        target: { value },
      } = event;
        setFormName(
          typeof value === 'string' ? value.split(',') : value,
        );
    };

    useEffect(() => {
        dispatch(setObjective({
            objective: formName
        }))
        dispatch(setFile({
            file: [],
            filename: '',
            file_id: ''
        }))
    }, [formName]);

    useEffect(() => {
      dispatch(setManageMemberStep({ manageMemberStep: 'manage_member' }))
      dispatch(setImportModal({ importModal: false }))

      return () => {
        dispatch(setFile({ file: [], file_id: '', filename: '' }))
        dispatch(setMemberSuccess({ member_success: [] }))
        dispatch(setMemberFail({ member_fail: [] }))
        dispatch(setObjective({ objective: ['One ID'] }))
      }
    }, [])

    return (
      <>
        {
          {
            manage_member: (
              <>
                <Row style={{ marginBottom: "20px", marginTop: "20px" }}>
                  <Col className="d-flex justify-content-start" xs={12} sm={6}>
                    <h4>จัดการข้อมูลรอลงทะเบียนสำหรับนักเรียน / นักศึกษา</h4>
                  </Col>
                  <Col className="d-flex justify-content-end" xs={12} sm={6}>
                    {/* <Button variant="outlined" startIcon={<AddIcon />}>
                    เพิ่มพนักงาน
                  </Button> &nbsp;&nbsp;&nbsp; */}
                    {(roles === "RA" || roles === "owner") && (
                      <>
                        <Button
                          // className='btn-upload-excel'
                          variant="contained"
                          startIcon={<DownloadIcon />}
                          onClick={() => {
                            donwloadExcel();
                          }}
                          style={{ marginRight: "10px", width: 177 }}
                          sx={
                            !!style.primary_color && {
                              backgroundColor: `${style.secondary_color} !important`,
                              color: fontColor(style.secondary_color),
                            }
                          }
                        >
                          ดาวน์โหลดไฟล์
                        </Button>
                        <Button
                          // className='btn-upload-excel'
                          variant="contained"
                          style={{ width: 177 }}
                          startIcon={<FileUploadIcon />}
                          sx={
                            !!style.primary_color && {
                              backgroundColor: `${style.secondary_color} !important`,
                              color: fontColor(style.secondary_color),
                            }
                          }
                          onClick={handleClickOpen}
                        >
                          อัปโหลดไฟล์ Excel
                        </Button>
                      </>
                    )}
                    &nbsp;&nbsp;&nbsp;
                    <BootstrapDialog
                      onClose={handleClose}
                      aria-labelledby="customized-dialog-title"
                      open={open}
                      sx={{
                        background: "transparent",
                      }}
                    >
                      <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                        style={{ textAlign: "center" }}
                      >
                        อัปโหลดไฟล์
                      </BootstrapDialogTitle>
                      <DialogContent>
                        <Typography gutterBottom>
                          <Row>
                            <Col className="align-self-center">
                              รูปแบบการนำเข้าข้อมูล :
                            </Col>
                            <Col className="align-self-center">
                              {services.includes(
                                "edu-student-pre-register-combine"
                              ) ? (
                                manageCheckbox()
                              ) : (
                                <Chip key={formName} label={formName} />
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Suspense fallback={<LoadingComponent />}>
                                <ExcelImportPreRegisterEduStudent />
                              </Suspense>
                            </Col>
                          </Row>
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant="outlined"
                          autoFocus
                          onClick={handleClose}
                          sx={{
                            color: `red`,
                            borderColor: `red`,
                          }}
                        >
                          ยกเลิก
                        </Button>
                        <Button
                          variant="contained"
                          autoFocus
                          onClick={() => {
                            if (file.length != 0) {
                              dispatch(
                                setManageMemberStep({
                                  manageMemberStep: "add_member",
                                })
                              );
                            } else {
                              message.error(`กรุณาเลือกไฟล์`);
                            }
                          }}
                          sx={
                            !!style.primary_color && {
                              backgroundColor: `${style.secondary_color} !important`,
                              color: fontColor(style.secondary_color),
                            }
                          }
                        >
                          อัปโหลด
                        </Button>
                      </DialogActions>
                    </BootstrapDialog>
                  </Col>
                </Row>
                <Row>
                  <Box sx={{ width: "100%", typography: "body1" }}>
                    <TabContext value={tabStep}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleChange}
                          aria-label="lab API tabs example"
                          textColor="secondary"
                          indicatorColor="secondary"
                          TabIndicatorProps={{
                            sx: !!style.secondary_color && {
                              backgroundColor: `${style.secondary_color} !important`,
                              color: fontColor(style.primary_color),
                            },
                          }}
                        >
                          <Tab label="จัดการสมาชิก" value={1} />
                          <Tab label="ประวัติการเพิ่ม" value={2} />
                        </TabList>
                      </Box>
                      <TabPanel value={1}>
                        <StudentTable />
                      </TabPanel>
                      <TabPanel value={2}>
                        <AddStudentHistory />
                      </TabPanel>
                    </TabContext>
                  </Box>
                </Row>
              </>
            ),
            add_member: (
              <>
                <AddStudent
                  backHistory={() => {
                    dispatch(
                      setManageMemberStep({
                        manageMemberStep: "history_detail",
                      })
                    );
                  }}
                  backStep={() => {
                    dispatch(
                      setManageMemberStep({
                        manageMemberStep: "manage_member",
                      })
                    );
                    setOpen(false);
                    dispatch(
                      setFile({
                        file: [],
                        filename: "",
                        file_id: "",
                      })
                    );
                    dispatch(
                      setMemberFail({
                        member_fail: [],
                      })
                    );
                    dispatch(
                      setMemberSuccess({
                        member_success: [],
                      })
                    );
                  }}
                  typeTemplate={formName}
                />
              </>
            ),
            history_detail: (
              <StudentHistoryDetail
                backStep={() => {
                  setStep("manage_member");
                }}
              />
            ),
          }[step]
        }
      </>
    );
}
export default Student;